<template>
  <div>
    <br />
    <h2 class="mainHead text-center pt-4">Full Stack Web Development</h2>
    <p class="subHead pt-4 text-center">
      Become a job-ready software developer in 30 weeks at no upfront fees. Pay
      us only if you get a job that pays you ₹5,00,000/- per year or more!
    </p>

    <base-section id="contact-us" class="green lighten-5 pt-5" space="30">
      <v-container>
        <v-row justify="center">
          <v-col cols="4">
            <v-btn icon class="mx-10">
              <v-icon size="40" color="green darken-2">mdi-account-tie</v-icon>
            </v-btn>
            <h3 class="pt-3">2100+ Students <br />Currently Enrolled</h3>
          </v-col>
          <v-col cols="4">
            <v-btn icon class="mx-10">
              <v-icon size="40" color="green darken-2">mdi-bag-checked</v-icon>
            </v-btn>
            <h3 class="pt-3">96% Placement <br />Success Rate</h3>
          </v-col>
          <v-col cols="2">
            <v-btn icon class="mx-10">
              <v-icon size="40" color="green darken-2"
                >mdi-currency-rupee</v-icon
              >
            </v-btn>
            <h3 class="pt-3">
              36 LPA Highest<br />
              Salary
            </h3>
          </v-col>
        </v-row>
      </v-container>
    </base-section>

    <v-row class="pt-5 pl-3">
      <v-col cols="3">
        <v-card class="mx-auto cardOne" max-width="344" outlined>
          <v-list-item three-line>
            <v-list-item-content>
              <h3 class="pt-2 pb-5">Full Stack Web Development- Part Time</h3>
              <hr />
              <div class="pt-5">
                <a href="#nextBarch">
                  <p><b>Next Batch</b></p></a
                >
              </div>
              <div class="pt-5">
                <a href="#courseDetails">
                  <p><b>Course Details</b></p></a
                >
              </div>
              <div class="pt-5">
                <a href="#eligibility">
                  <p><b>Eligibility</b></p></a
                >
              </div>
              <div class="pt-5">
                <a href="#learn">
                  <p><b>What You'll Learn</b></p></a
                >
              </div>
              <div class="pt-5">
                <a href="#become">
                  <p><b>What you could Become</b></p></a
                >
              </div>
              <div class="pt-5">
                <a href="#studentTest">
                  <p><b>Student Testimonials</b></p></a
                >
              </div>
              <div class="pt-5">
                <a href="#feeIsa">
                  <p><b>Fees & ISA</b></p></a
                >
              </div>
              <div class="pt-5">
                <a href="#hirePrtner">
                  <p><b>Hiring Partners</b></p></a
                >
              </div>
              <div class="pt-5">
                <a href="#addProcess"
                  ><p><b>Admission Process</b></p></a
                >
              </div>
              <div class="pt-5">
                <a href="#addProcess"
                  ><p><b>FAQS</b></p></a
                >
              </div>
              <v-btn
                depressed
                color="green lighten-1"
                @click.stop="dialog = true"
                class="ma-2 white--text"
              >
                <b>Apply now for free</b>
              </v-btn>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
      <v-col cols="9"
        ><p
          style="
            background-color: #43a047;
            color: #ffffff;
            border-radius: 8px;
            font-size: 16px;
            padding: 40px;
            margin: 5px;
          "
          align="justify"
        >
          <v-btn depressed color="green lighten-1" class="ma-2 white--text">
            <v-icon class="mx-1" right dark> mdi-clock-outline </v-icon>
            <b>Part Time</b>
          </v-btn>
          <v-btn depressed color="green lighten-1" class="ma-2 white--text">
            <v-icon class="mx-1" right dark> mdi-calendar-month </v-icon>
            <b>30 Weeks</b>
          </v-btn>
        </p>
        <div id="nextBarch">
          <h2 class="text-center pt-4">Next Intake</h2>
          <div>
            <div
              style="
                border: 1px solid #d7dbdd;
                color: black;
                border-radius: 30px;
                font-size: 16px;
                padding: 40px;
                margin: 5px;
              "
              align="justify"
            >
              <b>Web 21</b>
              <br />
              Starts 25 July 2022

              <v-btn
                depressed
                color="green lighten-1"
                @click.stop="model = true"
                class="ma-2 white--text"
              >
                <b>Enroll</b>
              </v-btn>
            </div>
          </div>
        </div>

        <v-row class="pl-5">
          &nbsp; <b><p class="green--text">Upcoming Batches</p></b>
        </v-row>
        <v-row class="pl-5">
          <v-col cols="6"
            ><b>Web 22 <br />Web 23 </b></v-col
          >
          <v-col cols="6"
            >Starts 29 August 2022<br />
            Starts 03 October 2022</v-col
          >
        </v-row>
        <v-row class="pl-4 pt-5" id="courseDetails">
          <h2 class="pt-5">Course Details</h2>
          <p class="pt-3">
            In a duration of 30 weeks, the course requires a commitment from 9am
            to 9pm for 6 days a week in an intensive and immersive curriculum.
          </p>
        </v-row>
        <v-row justify="center">
          <v-col cols="4">
            <p
              style="
                background-color: #e8f5e9;
                color: black;
                border-radius: 8px;
                font-size: 16px;
                padding: 40px;
                margin: 5px;
              "
              align="justify"
            >
              <v-btn icon class="mx-10 text-center">
                <v-icon size="40" color="green darken-2"
                  >mdi-calendar-month</v-icon
                >
              </v-btn>
              <br /><b
                >30 Weeks
                <br />

                (7 Months)</b
              >
              <br />
              <br />
            </p>
          </v-col>

          <v-col cols="4">
            <p
              style="
                background-color: #e8f5e9;
                color: black;
                border-radius: 8px;
                font-size: 16px;
                padding: 40px;
                margin: 5px;
              "
              align="justify"
            >
              <v-btn icon class="mx-10 text-center">
                <v-icon size="40" color="green darken-2"
                  >mdi-clock-outline</v-icon
                >
              </v-btn>
              <br /><b
                >9 am to 11 am <br />1 pm to 3pm
                <br />

                Saturday to Sunday</b
              >
            </p>
          </v-col>

          <v-col cols="4">
            <p
              style="
                background-color: #e8f5e9;
                color: black;
                border-radius: 8px;
                font-size: 16px;
                padding: 40px;
                margin: 5px;
              "
              align="justify"
            >
              <v-btn icon class="mx-10 text-center">
                <v-icon size="40" color="green darken-2"
                  >mdi-bag-checked</v-icon
                >
              </v-btn>
              <br /><b>96% Placements</b>
              <br />
              <br />
              <br />
            </p>
          </v-col>
        </v-row>
        <div id="eligibility">
          <div
            style="
              border: 1px solid #d7dbdd;
              color: black;
              border-radius: 8px;
              font-size: 16px;
              padding: 40px;
              margin: 5px;
            "
            align="justify"
          >
            <h2 class="text-center">Minimum Criteria</h2>
            <p class="text-center pt-3">
              You should meet the following requirements to be eligible for this
              course.
            </p>
            <v-row>
              <v-col cols="6">
                <v-row>
                  <v-col cols="2">
                    <v-btn icon class="mx-5 text-center">
                      <v-icon size="30" color="green darken-2"
                        >mdi-card-account-details-outline</v-icon
                      >
                    </v-btn>
                  </v-col>
                  <v-col cols="10">
                    <div class="pl-4">
                      <b> Qualification</b><br />
                      Cleared Ordinary Level Examination (O/L), Ready To Take a
                      Job Immediately After Course Finishes
                    </div></v-col
                  >
                </v-row>
                <br />
                <br />
                <v-row>
                  <v-col cols="2">
                    <v-btn icon class="mx-5 text-center">
                      <v-icon size="30" color="green darken-2"
                        >mdi-card-account-details-outline</v-icon
                      >
                    </v-btn>
                  </v-col>
                  <v-col cols="10">
                    <div class="pl-4">
                      <b> ID</b><br />
                      Nation Identiy Card (NIC)
                    </div></v-col
                  >
                </v-row>
                <br />
                <br />
                <v-row>
                  <v-col cols="2">
                    <v-btn icon class="mx-5 text-center">
                      <v-icon size="30" color="green darken-2"
                        >mdi-account-tie-voice</v-icon
                      >
                    </v-btn>
                  </v-col>
                  <v-col cols="10">
                    <div class="pl-4">
                      <b> Communication Skills</b><br />
                      Basic English - speaking, reading and writing
                    </div></v-col
                  >
                </v-row>
              </v-col>

              <v-col cols="6">
                <v-row>
                  <v-col cols="2">
                    <v-btn icon class="mx-5 text-center">
                      <v-icon size="30" color="green darken-2"
                        >mdi-account</v-icon
                      >
                    </v-btn>
                  </v-col>
                  <v-col cols="10">
                    <div class="pl-4">
                      <b> Age</b><br />
                      Min .20 yrs,<br />
                      Max. 20 yrs
                    </div></v-col
                  >
                </v-row>
                <br />
                <br />
                <v-row>
                  <v-col cols="2">
                    <v-btn icon class="mx-5 text-center">
                      <v-icon size="30" color="green darken-2"
                        >mdi-earth</v-icon
                      >
                    </v-btn>
                  </v-col>
                  <v-col cols="10">
                    <div class="pl-4">
                      <b> Hardware</b><br />
                      A laptop, uninterrupted internet connection
                    </div></v-col
                  >
                </v-row>
                <br />
                <br /></v-col
            ></v-row>
          </div>
        </div>
        <h2 class="text-left pt-4">Meet Your Instructors</h2>
        <p class="text-left pt-3">
          Being accomplished developers themselves, the Curriculum Team is an
          experienced group of coding instructors.
        </p>
        <br />
        <p>INSTRUCTORS</p>
        <hr />
        <v-row>
          <v-col cols="4">
            <v-card class="mx-auto my-12" max-width="374">
              <template slot="progress">
                <v-progress-linear
                  color="deep-purple"
                  height="10"
                  indeterminate
                ></v-progress-linear>
              </template>

              <v-img height="250" src="@/assets/user-1.jpg"></v-img>

              <h3 class="pl-3 pt-3 pb-3 text-center">Christina</h3>
              <v-divider class="mx-4"></v-divider>
              <br />
              <v-img height="50" width="190" src="@/assets/logo.png"></v-img>
              <br />
            </v-card>
          </v-col>
          <v-col cols="4">
            <v-card class="mx-auto my-12" max-width="374">
              <template slot="progress">
                <v-progress-linear
                  color="deep-purple"
                  height="10"
                  indeterminate
                ></v-progress-linear>
              </template>

              <v-img height="250" src="@/assets/team-2.jpg"></v-img>

              <h3 class="pl-3 pt-3 pb-3 text-center">Arjun</h3>
              <v-divider class="mx-4"></v-divider><br />
              <v-img height="50" width="190" src="@/assets/logo.png"></v-img
              ><br />
            </v-card>
          </v-col>
          <v-col cols="4">
            <v-card class="mx-auto my-12" max-width="374">
              <template slot="progress">
                <v-progress-linear
                  color="deep-purple"
                  height="10"
                  indeterminate
                ></v-progress-linear>
              </template>

              <v-img height="250" src="@/assets/team-1.jpg"></v-img>

              <h3 class="pl-3 pt-3 pb-3 text-center">John</h3>
              <v-divider class="mx-4"></v-divider><br />
              <v-img height="50" width="190" src="@/assets/logo.png"></v-img
              ><br />
            </v-card>
          </v-col>
        </v-row>

        <v-row id="learn">
          <h2 class="text-left pt-4">What you'll learn</h2></v-row
        >
        <v-row class="pt-3">
          <v-col cols="3">
            <v-img height="60" width="50" src="@/assets/one.png"></v-img>
          </v-col>
          <v-col cols="3">
            <v-img height="60" width="50" src="@/assets/two.png"></v-img>
          </v-col>
          <v-col cols="3">
            <v-img height="60" width="50" src="@/assets/js.png"></v-img>
          </v-col>
          <v-col cols="3">
            <v-img height="60" width="50" src="@/assets/q.svg"></v-img>
          </v-col>
          <v-col cols="3">
            <v-img height="60" width="60" src="@/assets/njs.png"></v-img>
          </v-col>
          <v-col cols="3">
            <v-img height="60" width="70" src="@/assets/vue.png"></v-img
          ></v-col>
          <v-col cols="3">
            <v-img height="60" width="60" src="@/assets/h.svg"></v-img
          ></v-col>
          <v-col cols="3">
            <v-img height="60" width="90" src="@/assets/jq.png"></v-img
          ></v-col>
          <v-col cols="3">
            <v-img height="60" width="90" src="@/assets/p.png"></v-img>
          </v-col>
          <v-col cols="3">
            <v-img height="60" width="90" src="@/assets/md.png"></v-img
          ></v-col>
          <v-col cols="3">
            <v-img height="60" width="110" src="@/assets/php.png"></v-img
          ></v-col>
          <v-col cols="3">
            <v-img height="60" width="120" src="@/assets/aws.png"></v-img
          ></v-col>
          <v-col cols="3">
            <v-img height="60" width="110" src="@/assets/ms.png"></v-img></v-col
        ></v-row>

        <v-row class="pt-5">
          <v-col cols="6"
            ><p>
              <b> WEEK 1-5</b>
              <br />
              Programming Basics in JavaScript, Developer tools and workflow,
              Introduction to Web, JavaScript on the browser, Data Structures
              and Algorithms
            </p></v-col
          >

          <v-col cols="6"
            ><b>WEEK 6-10</b>
            <br />
            Modern Javascript, Basics of Unit Testing, Advanced CSS,
            Introduction to React and React Ecosystem, Data Structures and
            Algorithms
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6"
            ><b>WEEK 11-15</b>
            <br />
            UI Libraries, Reusable Components, Routing and Advanced APIs,
            Deployment, Unit Testing, and end to end testing, Redux and Hooks,
            Data Structures and Algorithms
          </v-col>
          <v-col cols="6"
            ><b>WEEK 16-20</b>
            <br />
            Node.js and Express.js, Microservices, MongoDB, Data Structures and
            Algorithms
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6"
            ><b>WEEK 21-25</b>
            <br />
            System design basics, How do they scale?, All about operating
            systems, Data Structures and Algorithms
          </v-col>
          <v-col cols="6"
            ><b>WEEK 26-30</b>
            <br />
            Projects, Interview Preparation
          </v-col>
        </v-row>

        <br />
        <div
          style="
            background-color: #e8f5e9;
            color: black;
            border-radius: 8px;
            font-size: 16px;
            padding: 40px;
            margin: 5px;
          "
          align="justify"
          id="become"
        >
          <h2 class="text-center pt-4">What You Could Become</h2>
          <p class="text-center pt-3">
            Tech job landscape in itself is lucrative, dynamic and ever growing.
            The roles that are offered in software development are also highly
            diverse.
          </p>
          <v-row>
            <v-col cols="3">
              <div
                style="
                  background-color: #ffffff;
                  color: black;
                  border-radius: 8px;
                  height: 50px;
                  padding-left: 10px;
                "
              >
                Front-End Developer
              </div>
            </v-col>

            <v-col cols="3">
              <div
                style="
                  background-color: #ffffff;
                  color: black;
                  border-radius: 8px;
                  height: 30px;
                  padding-left: 10px;
                "
              >
                App Developer
              </div>
            </v-col>
            <v-col cols="3">
              <div
                style="
                  background-color: #ffffff;
                  color: black;
                  border-radius: 8px;
                  height: 30px;
                  padding-left: 10px;
                "
              >
                Web Programmer
              </div>
            </v-col>
            <v-col cols="3">
              <div
                style="
                  background-color: #ffffff;
                  color: black;
                  border-radius: 8px;
                  height: 30px;
                  padding-left: 10px;
                "
              >
                Mobile Developer
              </div>
            </v-col>
            <v-col cols="3">
              <div
                style="
                  background-color: #ffffff;
                  color: black;
                  border-radius: 8px;
                  height: 60px;
                  padding-left: 10px;
                "
              >
                Full Stack
                <br />Developer
              </div>
            </v-col>
            <v-col cols="3">
              <div
                style="
                  background-color: #ffffff;
                  color: black;
                  border-radius: 8px;
                  height: 30px;
                  padding-left: 10px;
                "
              >
                Software Engineer
              </div>
            </v-col>
            <v-col cols="3">
              <div
                style="
                  background-color: #ffffff;
                  color: black;
                  border-radius: 8px;
                  height: 30px;
                  padding-left: 10px;
                "
              >
                Backend Developer
              </div>
            </v-col>
            <v-col cols="3">
              <div
                style="
                  background-color: #ffffff;
                  color: black;
                  border-radius: 8px;
                  height: 30px;
                  padding-left: 10px;
                "
              >
                Programmer
              </div>
            </v-col>
            <v-col cols="3">
              <div
                style="
                  background-color: #ffffff;
                  color: black;
                  border-radius: 8px;
                  height: 30px;
                  padding-left: 10px;
                "
              >
                Web Developer
              </div>
            </v-col>
            <v-col cols="3">
              <div
                style="
                  background-color: #ffffff;
                  color: black;
                  border-radius: 8px;
                  height: 30px;
                  padding-left: 10px;
                "
              >
                UI Engineer
              </div>
            </v-col>
            <v-col cols="3">
              <div
                style="
                  background-color: #ffffff;
                  color: black;
                  border-radius: 8px;
                  height: 30px;
                  padding-left: 10px;
                "
              >
                Full Stack Engineer
              </div>
            </v-col>
            <v-col cols="3">
              <div
                style="
                  background-color: #ffffff;
                  color: black;
                  border-radius: 8px;
                  height: 30px;
                  padding-left: 10px;
                "
              >
                Backend Engineer
              </div>
            </v-col>
          </v-row>
        </div>

        <v-row id="studentTest">
          <h2 class="mainHeadSub text-center pt-3">
            Thousands Trust Masai to Launch Their Career
          </h2></v-row
        >
        <v-row class="pt-3">
          <v-col cols="4">
            <v-card class="mx-auto my-12" max-width="374">
              <template slot="progress">
                <v-progress-linear
                  color="deep-purple"
                  height="10"
                  indeterminate
                ></v-progress-linear>
              </template>

              <v-img height="250" src="@/assets/k.jpg"></v-img>

              <h3 class="pl-3 pt-3 pb-3 text-center">Lakshika</h3>
              <v-divider class="mx-4"></v-divider>
              <br />
            </v-card>
          </v-col>
          <v-col cols="4">
            <v-card class="mx-auto my-12" max-width="374">
              <template slot="progress">
                <v-progress-linear
                  color="deep-purple"
                  height="10"
                  indeterminate
                ></v-progress-linear>
              </template>

              <v-img height="250" src="@/assets/b.png"></v-img>

              <h3 class="pl-3 pt-3 pb-3 text-center">Branavan</h3>
              <v-divider class="mx-4"></v-divider><br />
            </v-card>
          </v-col>
          <v-col cols="4">
            <v-card class="mx-auto my-12" max-width="374">
              <template slot="progress">
                <v-progress-linear
                  color="deep-purple"
                  height="10"
                  indeterminate
                ></v-progress-linear>
              </template>

              <v-img height="250" src="@/assets/k.jpg"></v-img>
              <h3 class="pl-3 pt-3 pb-3 text-center">Kishanthini</h3>
              <v-divider class="mx-4"></v-divider>
              <br />
            </v-card>
          </v-col>
          <v-col cols="4">
            <v-card class="mx-auto my-12" max-width="374">
              <template slot="progress">
                <v-progress-linear
                  color="deep-purple"
                  height="10"
                  indeterminate
                ></v-progress-linear>
              </template>

              <v-img height="250" src="@/assets/b.png"></v-img>
              <h3 class="pl-3 pt-3 pb-3 text-center">Cotny Dilon</h3>
              <v-divider class="mx-4"></v-divider>
              <br />
            </v-card>
          </v-col>
        </v-row>

        <v-row align="center" class="pt-2 white--text" justify="space-around">
          <v-btn depressed color="green darken-1" class="ma-2 white--text">
            <b>more stories >></b>
          </v-btn></v-row
        >
        <br />

        <h2 class="text-center pt-5" id="feeIsa">
          Pay Through Income Share Agreement
        </h2>
        <p class="text-center pt-3">
          No loans, no collaterals, no interest rate.
        </p>
        <v-row
          ><a href=""><p class="pl-5">Learn more about Srilanka</p></a>
        </v-row>

        <v-row>
          <v-col cols="6">
            <v-row>
              <v-col cols="2">
                <v-btn icon class="mx-5 text-center">
                  <v-icon size="70" color="green darken-2"
                    >mdi-numeric-0</v-icon
                  >
                </v-btn>
              </v-col>
              <v-col cols="10">
                <div class="pl-4">
                  Apply and study for ZERO upfront fee
                </div></v-col
              >
            </v-row>
            <br />
            <br />
            <v-row>
              <v-col cols="2">
                <v-btn icon class="mx-5 text-center">
                  <v-icon size="50" color="green darken-2"
                    >mdi-bag-checked</v-icon
                  >
                </v-btn>
              </v-col>
              <v-col cols="10">
                <div class="pl-4">
                  The ISA is capped at a maximum repayment of ₹ 3 Lakhs
                </div></v-col
              >
            </v-row>
          </v-col>
          <v-col cols="6">
            <v-row>
              <v-col cols="2">
                <v-btn icon class="mx-5 text-center">
                  <v-icon size="40" color="green darken-2"
                    >mdi-credit-card-outline</v-icon
                  >
                </v-btn>
              </v-col>
              <v-col cols="10">
                <div class="pl-4">
                  Pay the course fee in 36 months or less from your post-course
                  salary, only when you earn ₹ 5LPA (CTC) or more.
                </div></v-col
              >
            </v-row>
          </v-col>
        </v-row>
        <div
          style="
            background-color: #e8f5e9;
            color: black;
            border-radius: 8px;
            font-size: 16px;
            padding: 40px;
            margin: 5px;
          "
          align="justify"
          id="hirePrtner"
        >
          <h2 class="text-center pt-4">Have a Dream Company In Mind?</h2>
          <h2 class="text-center pt-4">
            Meet Some Of Our 1200+ Hiring Partners
          </h2>
          <v-row>
            <v-col cols="4">
              <div
                style="
                  background-color: #ffffff;
                  color: black;
                  border-radius: 8px;
                  font-size: 16px;
                  padding: 40px;
                  margin: 5px;
                "
              >
                <v-img height="90" src="@/assets/smakintel.png"></v-img>
              </div>
            </v-col>
            <v-col cols="4">
              <div
                style="
                  background-color: #ffffff;
                  color: black;
                  border-radius: 8px;
                  font-size: 16px;
                  padding: 40px;
                  margin: 5px;
                "
              >
                <v-img height="90" src="@/assets/square-logo.png"></v-img>
              </div>
            </v-col>
          </v-row>
        </div>
        <br />
        <div
          style="
            background-color: #e8f5e9;
            color: black;
            border-radius: 8px;
            font-size: 16px;
            padding: 40px;
            margin: 5px;
          "
          align="justify"
          id="addProcess"
        >
          <h2 class="text-center pt-4">Admission Process</h2>
          <v-row justify="center">
            <v-col cols="6 ">
              <div
                style="
                  background-color: #ffffff;
                  color: black;
                  border-radius: 50px;
                "
              >
                <v-row>
                  <v-col cols="2">
                    <v-btn icon class="mx-5 text-center">
                      <v-icon size="60" color="green darken-2"
                        >mdi-numeric-1</v-icon
                      >
                    </v-btn>
                  </v-col>
                  <v-col cols="10" class="pl-5">Apply for the Program</v-col>
                </v-row>
              </div>
            </v-col>
            <br />
          </v-row>
          <v-row justify="center">
            <v-col cols="6 ">
              <div
                style="
                  background-color: #ffffff;
                  color: black;
                  border-radius: 50px;
                "
              >
                <v-row>
                  <v-col cols="2">
                    <v-btn icon class="mx-5 text-center">
                      <v-icon size="60" color="green darken-2"
                        >mdi-numeric-2</v-icon
                      >
                    </v-btn>
                  </v-col>
                  <v-col cols="10" class="pl-5">Crack the Admission Test</v-col>
                </v-row>
              </div>
            </v-col>
            <br />
          </v-row>
          <v-row justify="center">
            <v-col cols="6 ">
              <div
                style="
                  background-color: #ffffff;
                  color: black;
                  border-radius: 50px;
                "
              >
                <v-row>
                  <v-col cols="2">
                    <v-btn icon class="mx-5 text-center">
                      <v-icon size="60" color="green darken-2"
                        >mdi-numeric-3</v-icon
                      >
                    </v-btn>
                  </v-col>
                  <v-col cols="10" class="pl-5">Complete Documentation</v-col>
                </v-row>
              </div>
            </v-col>
            <br />
          </v-row>
          <v-row justify="center">
            <v-col cols="6 ">
              <div
                style="
                  background-color: #ffffff;
                  color: black;
                  border-radius: 50px;
                "
              >
                <v-row>
                  <v-col cols="2">
                    <v-btn icon class="mx-5 text-center">
                      <v-icon size="60" color="green darken-2"
                        >mdi-numeric-4</v-icon
                      >
                    </v-btn>
                  </v-col>
                  <v-col cols="10" class="pl-5"
                    >You are ready to join the batch</v-col
                  >
                </v-row>
              </div>
            </v-col>
            <br />
          </v-row>

          <div class="text-center pt-4">
            <v-btn
              rounded
              color="green darken-1"
              class="white--text"
              @click.stop="dialog = true"
              dark
            >
              <b>apply now for free</b></v-btn
            >
          </div>
        </div>
        <div class="pt-4" id="faqId">
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <b>What is the medium of instruction?</b>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                The medium of instruction at Masai is English. All lectures are
                delivered in English. As part of the curriculum, we also help
                you develop your written and verbal communication skills that
                help you become more employable.
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <b>
                  Will I receive a degree or certificate when I graduate from
                  Masai?</b
                >
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                We do issue a certificate of completion upon graduation. But,
                Masai School is not a degree institution and we do not grant
                Bachelors or Masters Degrees. The core focus at Masai School is
                on skill development and holistic learning. With that in mind,
                we have not tied up with any education institution for
                certification. We believe skills > degrees.
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <b
                  >The course hours don’t work for me. Can I attend classes in
                  my own time?</b
                >
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                No. You are required to attend classes in the defined time slot
                and are required to maintain 90% attendance for all our courses.
                If for any reason you are not able to attend your classes during
                your course, with prior permission, recorded lectures will be
                made available to you. However, please note, it won’t be as
                effective as attending live classes*
                <ul>
                  <li>
                    relaxations are provided to part time programs (working
                    professionals and final year students).
                  </li>
                </ul>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <b
                  >Are the offline campuses available for both Full-time &
                  Part-time courses?</b
                >
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                No, the offline campuses are only available for our Full-time
                Web Development courses.
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <b>What is the duration of the program?</b>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                Web Development:

                <b>Full Time Course</b><br />
                <i
                  >Duration: 30 Weeks<br />
                  Timing: Monday- Saturday, 9am- 9pm</i
                >

                <b>Part Time Course</b><br />
                <i
                  >Duration: 30 Weeks<br />
                  Timing: Monday- Friday, 8pm- 11pm; Saturday, 10am-5pm</i
                ><br /><br />

                <b>Data Analytics</b><br /><b
                  ><br />

                  Part Time Course</b
                ><br /><i>
                  Duration: 30 Weeks Timing: Tuesday - Saturday, 8pm- 11pm;
                  Sunday, 10am-5pm</i
                ><br /><br />

                <b>UI/UX Design:</b><br />

                <b>Full Time Course</b><br />
                <li>Duration: 25 Weeks Timing: Monday - Friday, 10am - 5pm</li>
                <br /><br />

                <b>Part Time Course</b><br /><i>
                  Duration: 25 Weeks<br />
                  Timing: 10am - 4pm, Saturday & Sunday; 8pm - 10pm, Tuesday &
                  Thursday</i
                >
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <b> Do you offer loaner laptops for prospective students?</b>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                Not at the moment.
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <b> What computer specs do I need?</b>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                For our Web Development Courses:<br />
                Minimum<br />
                1.6 GHz Processor<br />
                4 GB RAM**(For Full stack Android development - 8 GB RAM)**<br />
                120 GB Hard Drive<br />
                Web Cam<br />
                Microphone <br /><br /><br />‍ Recommended<br />
                2 GHz Processor<br />
                8 GB RAM<br />
                256 GB Hard Drive (preferably solid state) ‍<br /><br /><br />

                Please Note: Recommended operating systems (in descending
                order): Ubuntu, macOS, Windows 10<br />
                <br /><br />
                For our UI/UX Design Courses:<br />
                Minimum<br />
                Intel i3<br />
                1.6 GHz Processor<br />
                4 GB RAM 120 GB Hard Drive<br />
                Web Cam<br />
                Microphone<br /><br /><br />

                Recommended<br />
                Intel i5 and above<br />
                2 GHz Processor<br />
                8 GB RAM<br />
                256 GB Hard Drive (preferably solid state)<br /><br /><br />

                Note: You must have a Windows 10 or above operating system OR a
                Mac system with iOS 10 and above for the design softwares to
                run.
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <b> Does college CGPA play any role in the program?</b>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                No, your college CGPA does not play any role in your entry to
                our courses..
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <b>What do I do if I don't have a Pan Card/Adhaar Card?</b>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                As both are mandatory for you to apply for any of our courses,
                we would suggest you apply for these. These are required for the
                verification of your profile.
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <b>
                  What do you look for in candidates when they apply to Masai
                  School?</b
                >
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                Masai School is a fast-paced, immersive, online education
                experience. It's important to ask yourself, "Is this right for
                me?" Below are a few of the qualities it will take to be
                successful in our courses:
                <br />
                <ul>
                  <li>Determination</li>
                  <li>Proactiveness</li>
                  <li>Career-focussed</li>
                </ul>
                <br />
                Are you a self-learner?<br />
                Learning to code or design is only one piece of the puzzle.
                You'll rarely be shown how to solve problems in the workplace,
                so Masai students graduate with the ability to autonomously
                tackle unique problems wherever they face them.
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <div id="master">
        <div id="number">
          <h2 class="text-center pt-4">
            Connect with a growing<br />
            community of learners
          </h2>
          <div class="pt-4">
            <v-btn color="white" class="ma-2 black--text">
              <v-icon class="mx-1" size="20" color="green darken-2" right dark>
                mdi-android </v-icon
              >&nbsp;&nbsp;Join our dicord
            </v-btn>
          </div>
        </div>
        <div id="content">
          <h2 class="text-center pt-4">
            Have more<br />
            questions?
          </h2>
          <div class="pt-4">
            <v-btn class="ma-2" outlined color="green">
              <a href="#faqId"> <b>check our faqs</b></a>
            </v-btn>
          </div>
        </div>
      </div>
    </v-row>
    <div class="text-center">
      <v-dialog v-model="dialog" width="500">
        <v-card>
          <iframe
            width="640px"
            height="480px"
            src="https://forms.office.com/Pages/ResponsePage.aspx?id=DQSIkWdsW0yxEjajBLZtrQAAAAAAAAAAAAMAAEiFohhURU8wOVVWNEZKVzg1WUs3SFI4RURPNDZWSi4u&embed=true"
            frameborder="0"
            marginwidth="0"
            marginheight="0"
            style="border: none; max-width: 100%; max-height: 100vh"
            allowfullscreen
            webkitallowfullscreen
            mozallowfullscreen
            msallowfullscreen
          >
          </iframe>
        </v-card>
      </v-dialog>
    </div>

    <v-dialog v-model="model" width="500">
      <iframe
        src="https://docs.google.com/forms/d/e/1FAIpQLSfDluvFwr03M3k5GUksUOtdLGvL-k4imi7TJzM60ZbLxgjTkA/viewform?embedded=true"
        width="640"
        height="489"
        frameborder="0"
        marginheight="0"
        marginwidth="0"
        >Loading…</iframe
      >
    </v-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialog: false,
      model: false,
    };
  },
};
</script>
<style  scoped>
.v-dialog::-webkit-scrollbar-thumb {
  background-color: #d6dee1;
  border-radius: 20px;
  border: 6px solid transparent;
  background-clip: content-box;
}

a:link {
  color: black;
  text-decoration: none;
}

a:visited {
  color: black;
  background-color: transparent;
  text-decoration: none;
}

a:hover {
  color: green;
  background-color: transparent;
  text-decoration: none;
}

a:active {
  color: yellow;
  background-color: transparent;
  text-decoration: none;
}
#master {
  display: table-row;
}
#number,
#content {
  display: table-cell;
}
#number {
  background: #e8f5e9;
  width: 600px;
  vertical-align: middle;
  text-align: center;
}
#content {
  background: #fef9e7;
  width: 600px;
  min-height: 300px;
  text-align: center;
}
.mainHead {
  font-size: 50px;
}
.mainHeadSub {
  font-size: 35px;
}
.subHead {
  font-size: 20px;
}
.v-card {
  box-shadow: rgba(17, 12, 46, 0.15) 0px 48px 100px 0px;
}
.cardOne {
  position: sticky;
  top: 0;
}
hr {
  border: 1px solid green;
}
</style>
